export default  {
    homepage : "//mv1.in/ContentManager2/v1/fetchHomePage",
    subcat : "//mv1.in/ContentManager2/v1/fetchCategories?categoryId=<categoryId>",
    aboutus : "//mv1.in/ContentManager2/v1/fetchSettings?settingKey=aboutUs",
    faq : "//mv1.in/ContentManager2/v1/fetchSettings?settingKey=faq",
    userplaylist : "//mv1.in/ContentManager2/v1/getUserPlaylist",
    addUserPlayList : "//mv1.in/ContentManager2/v1/postUserPlaylist",
    deleteUserPlaylist : "//mv1.in/ContentManager2/v1/deleteUserPlaylist",
    saveLogs : "//mv1.in/AppLogger/v1/saveLogs"
    
}